import React, { useEffect } from 'react';
import { useUserQuery } from 'src/common/hooks/useUserQuery';
import { useLoggedInGuard } from 'src/common/guards/useLoggedInGuard';
import { useDispatch } from 'react-redux';
import { layoutActions } from 'src/state/layout/layoutActions';
import { Layout } from 'src/common/components/Layout';
import { MenuItem } from 'src/common/components/Layout/config';
import { HomepageRoute } from 'src/public/publicRoutes';
import { UserPageDesktopMenu } from 'src/user/common/components/UserPageDesktopMenu';
import { UserPageMobileMenu } from 'src/user/common/components/UserPageMobileMenu';
import { useRouter } from 'next/router';
import { WithClientOnly } from 'src/lib/SSR/ClientOnly/ClientOnly';

export const leftMenuItems: MenuItem[] = [{ label: 'Strona główna', url: HomepageRoute }];

export const WithUserModuleLayout = WithClientOnly(({ children }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const shouldRender = useLoggedInGuard({
    pathname: router.pathname,
    publicRoute: router.pathname === 'user',
    query: router.query,
  });
  const { data: user } = useUserQuery();

  useEffect(() => {
    dispatch(layoutActions.setActivePanelCategory(router.pathname));

    return () => {
      dispatch(layoutActions.setActivePanelCategory(null));
    };
  }, [router.pathname]);

  if (!shouldRender) {
    return null;
  }

  return user ? (
    <Layout
      leftMenuItems={leftMenuItems}
      leftPanel={<UserPageDesktopMenu />}
      rightMenuItems={null}
      rightPanel={null}
      title="Profil użytkownika"
      wideContent
      widget={<UserPageMobileMenu />}
      widgetPadding={64}
      scrollToTopButton
    >
      {children}
    </Layout>
  ) : null;
});
